import { Howl, Howler } from "howler";
import { randomInt } from "../helpers/random";
import store from "../store";
import { getMute } from "../reducers/sound/selectors";
import { getLang } from "../reducers/crossword/selectors";

export const ocean = new Howl({
  src: "/sounds/ocean.mp3",
  loop: true,
  volume: 0.1
});
export const bells = new Howl({ src: "/sounds/bell.mp3", volume: 0.2 });
export const seagull1 = new Howl({ src: "/sounds/seagull1.mp3", volume: 0.1 });
export const seagull2 = new Howl({ src: "/sounds/seagull2.mp3", volume: 0.1 });
export const seagull3 = new Howl({ src: "/sounds/seagull3.mp3", volume: 0.1 });
export const seagull4 = new Howl({ src: "/sounds/seagull4.mp3", volume: 0.1 });
export const tern1 = new Howl({ src: "/sounds/tern1.mp3", volume: 0.1 });
export const creaking1 = new Howl({
  src: "/sounds/creaking1.mp3",
  volume: 0.1
});

export const yay = new Howl({ src: "/sounds/yay.mp3" });
export const drop = new Howl({ src: "/sounds/drop.mp3" });
export const regenerate = new Howl({ src: "/sounds/regenerate.mp3" });

export const alphabet = {
  sv: {
    A: new Howl({ src: "/sounds/sv/A.mp3", preload: false }),
    B: new Howl({ src: "/sounds/sv/B.mp3", preload: false }),
    C: new Howl({ src: "/sounds/sv/C.mp3", preload: false }),
    D: new Howl({ src: "/sounds/sv/D.mp3", preload: false }),
    E: new Howl({ src: "/sounds/sv/E.mp3", preload: false }),
    F: new Howl({ src: "/sounds/sv/F.mp3", preload: false }),
    G: new Howl({ src: "/sounds/sv/G.mp3", preload: false }),
    H: new Howl({ src: "/sounds/sv/H.mp3", preload: false }),
    I: new Howl({ src: "/sounds/sv/I.mp3", preload: false }),
    J: new Howl({ src: "/sounds/sv/J.mp3", preload: false }),
    K: new Howl({ src: "/sounds/sv/K.mp3", preload: false }),
    L: new Howl({ src: "/sounds/sv/L.mp3", preload: false }),
    M: new Howl({ src: "/sounds/sv/M.mp3", preload: false }),
    N: new Howl({ src: "/sounds/sv/N.mp3", preload: false }),
    O: new Howl({ src: "/sounds/sv/O.mp3", preload: false }),
    P: new Howl({ src: "/sounds/sv/P.mp3", preload: false }),
    Q: new Howl({ src: "/sounds/sv/Q.mp3", preload: false }),
    R: new Howl({ src: "/sounds/sv/R.mp3", preload: false }),
    S: new Howl({ src: "/sounds/sv/S.mp3", preload: false }),
    T: new Howl({ src: "/sounds/sv/T.mp3", preload: false }),
    U: new Howl({ src: "/sounds/sv/U.mp3", preload: false }),
    V: new Howl({ src: "/sounds/sv/V.mp3", preload: false }),
    W: new Howl({ src: "/sounds/sv/W.mp3", preload: false }),
    X: new Howl({ src: "/sounds/sv/X.mp3", preload: false }),
    Y: new Howl({ src: "/sounds/sv/Y.mp3", preload: false }),
    Z: new Howl({ src: "/sounds/sv/Z.mp3", preload: false }),
    Å: new Howl({ src: "/sounds/sv/Å.mp3", preload: false }),
    Ä: new Howl({ src: "/sounds/sv/Ä.mp3", preload: false }),
    Ö: new Howl({ src: "/sounds/sv/Ö.mp3", preload: false })
  },
  en: {
    A: new Howl({ src: "/sounds/en/A.mp3", preload: false }),
    B: new Howl({ src: "/sounds/en/B.mp3", preload: false }),
    C: new Howl({ src: "/sounds/en/C.mp3", preload: false }),
    D: new Howl({ src: "/sounds/en/D.mp3", preload: false }),
    E: new Howl({ src: "/sounds/en/E.mp3", preload: false }),
    F: new Howl({ src: "/sounds/en/F.mp3", preload: false }),
    G: new Howl({ src: "/sounds/en/G.mp3", preload: false }),
    H: new Howl({ src: "/sounds/en/H.mp3", preload: false }),
    I: new Howl({ src: "/sounds/en/I.mp3", preload: false }),
    J: new Howl({ src: "/sounds/en/J.mp3", preload: false }),
    K: new Howl({ src: "/sounds/en/K.mp3", preload: false }),
    L: new Howl({ src: "/sounds/en/L.mp3", preload: false }),
    M: new Howl({ src: "/sounds/en/M.mp3", preload: false }),
    N: new Howl({ src: "/sounds/en/N.mp3", preload: false }),
    O: new Howl({ src: "/sounds/en/O.mp3", preload: false }),
    P: new Howl({ src: "/sounds/en/P.mp3", preload: false }),
    Q: new Howl({ src: "/sounds/en/Q.mp3", preload: false }),
    R: new Howl({ src: "/sounds/en/R.mp3", preload: false }),
    S: new Howl({ src: "/sounds/en/S.mp3", preload: false }),
    T: new Howl({ src: "/sounds/en/T.mp3", preload: false }),
    U: new Howl({ src: "/sounds/en/U.mp3", preload: false }),
    V: new Howl({ src: "/sounds/en/V.mp3", preload: false }),
    W: new Howl({ src: "/sounds/en/W.mp3", preload: false }),
    X: new Howl({ src: "/sounds/en/X.mp3", preload: false }),
    Y: new Howl({ src: "/sounds/en/Y.mp3", preload: false }),
    Z: new Howl({ src: "/sounds/en/Z.mp3", preload: false })
  },
  ru: {}
};

export const playChar = char => {
  char = char.toUpperCase();
  const lang = getCurrentLang();
  if (char in alphabet[lang]) {
    alphabet[lang][char].load().play();
  }
};

const ambientSounds = [
  creaking1,
  seagull1,
  seagull2,
  seagull3,
  seagull4,
  tern1,
  bells
];
const playRandomAmbience = () =>
  setTimeout(() => {
    ambientSounds[randomInt(0, ambientSounds.length)].play();
    playRandomAmbience();
  }, randomInt(0, 30000));

export const playAmbientSounds = () => {
  ocean.play();
  playRandomAmbience();
};

const getCurrentLang = () => getLang(store.getState());
const isMute = () => getMute(store.getState());
export const mute = () => Howler.mute(true);
export const checkMute = () => Howler.mute(isMute());



// WEBPACK FOOTER //
// ./src/sounds/index.js